<template>
    <b-card no-body>
        <b-card-header class="container-fluid">
            {{ $t('prod_ingredientproduction', { ns: 'production' }) }}
            <b-form-checkbox
                class="float-right"
                v-if="configUseFahrenheit"
                v-model="showFahrenheit"
            >
                {{ $t('prod_usefahrenheit', { ns: 'production' }) }}
            </b-form-checkbox>
        </b-card-header>
        <div>
            <b-alert
                v-model="showDismissibleAlert"
                variant="danger"
                dismissible
            >
                {{ alertText }}
            </b-alert>
            <b-card>
                <b-tab :title="$t('com_basis', { ns: 'common' })" active>
                    <b-input-group
                        v-if="!isSelected"
                        :prepend="$t('com_product', { ns: 'common' })"
                    >
                        <b-form-select
                            v-model="productieIngredientID"
                            :options="prodIngredientList"
                            @input="setProduct"
                            :disabled="isSelected"
                            :state="isSelected"
                        >
                            <template #first>
                                <b-form-select-option value=""
                                    >--
                                    {{
                                        $t('com_selecteer', {
                                            ns: 'common'
                                        })
                                    }}
                                    --</b-form-select-option
                                >
                            </template>
                        </b-form-select>
                    </b-input-group>

                    <b-card-text>
                        <b-input-group
                            :prepend="$t('com_amount', { ns: 'common' })"
                            :label="$t('com_amount', { ns: 'common' })"
                            :disabled="!nieuw"
                        >
                            <b-form-input
                                :placeholder="
                                    $t('com_amount', { ns: 'common' })
                                "
                                type="number"
                                step="1"
                                v-model.number="localItem.hoeveelheid"
                                :state="
                                    localItem.hoeveelheid &&
                                    localItem.hoeveelheid > 0
                                "
                                :disabled="!nieuw"
                                @change="setChanged"
                            ></b-form-input>
                            <lookup-combo
                                :key="aangeraakt"
                                v-model="localItem.eenheid"
                                v-bind:combotype="lctypeUnits"
                                v-bind:discrim="buProductString"
                                :doCheckState="true"
                                :disabled="!nieuw"
                                @change="setChanged"
                            ></lookup-combo>
                        </b-input-group>
                        <b-input-group
                            :prepend="$t('com_location', { ns: 'common' })"
                            :label="$t('com_location', { ns: 'common' })"
                            :disabled="!nieuw"
                        >
                            <lookup-combo
                                id="input-itemloc"
                                v-model="localItem.locatieID"
                                v-bind:combotype="lctypeLocation"
                                @change="setChanged"
                                :disabled="!nieuw"
                            ></lookup-combo>
                        </b-input-group>
                        <b-input-group
                            style="width: 80%"
                            :prepend="$t('com_start', { ns: 'common' })"
                            :label="$t('com_start', { ns: 'common' })"
                            :disabled="!editAllowed"
                            class="form-inline"
                        >
                            <b-input-group v-if="!useTimeInput">
                                <b-form-timepicker
                                    v-model="tijdstart"
                                    @input="set_inputTijdStart"
                                    :disabled="!editAllowed"
                                    :class="giveBGclass"
                                />
                                <cheese-tijd
                                    v-model="datumtijdstart"
                                    @change="set_inputTijdStart"
                                    :disabled="!editAllowed"
                                />
                            </b-input-group>
                            <b-input-group v-if="useTimeInput">
                                <b-form-input
                                    v-model="localDateStart"
                                    :type="'date'"
                                    @blur="setDatumTijdStart"
                                    :disabled="!editAllowed"
                                    :class="giveBGclass"
                                ></b-form-input>
                                <b-form-input
                                    v-model="localTijdStart"
                                    :type="'time'"
                                    @blur="setDatumTijdStart"
                                    :disabled="!editAllowed"
                                    :class="giveBGclass"
                                ></b-form-input>
                            </b-input-group>
                            <temperature-input
                                v-model.number="localItem.startTemperatuur"
                                @change="setChanged"
                                :editAllowed="editAllowed"
                                :showFahrenheit="showFahrenheit"
                            />
                        </b-input-group>
                        <b-input-group
                            style="width: 80%"
                            :prepend="$t('com_eind', { ns: 'common' })"
                            :label="$t('com_eind', { ns: 'common' })"
                            :disabled="!editAllowed"
                            class="form-inline"
                        >
                            <b-input-group v-if="!useTimeInput">
                                <b-form-timepicker
                                    v-model="tijdeind"
                                    @input="set_inputTijdEind"
                                    :disabled="!editAllowed"
                                    :class="giveBGclass"
                                />
                                <cheese-tijd
                                    v-model="datumtijdeind"
                                    @change="set_inputTijdEind"
                                    :disabled="!editAllowed"
                                />
                            </b-input-group>
                            <b-input-group v-if="useTimeInput">
                                <b-form-input
                                    v-model="localDateEind"
                                    :type="'date'"
                                    @blur="setDatumTijdEind"
                                    :disabled="!editAllowed"
                                    :class="giveBGclass"
                                ></b-form-input>
                                <b-form-input
                                    v-model="localTijdEind"
                                    :type="'time'"
                                    @blur="setDatumTijdEind"
                                    :disabled="!editAllowed"
                                    :class="giveBGclass"
                                ></b-form-input>
                            </b-input-group>
                            <temperature-input
                                v-model.number="localItem.eindTemperatuur"
                                @change="setChanged"
                                :editAllowed="editAllowed"
                                :showFahrenheit="showFahrenheit"
                            />
                        </b-input-group>
                        <div class="form-inline">
                            <b-input-group
                                style="width: 80%"
                                :prepend="$t('com_avg', { ns: 'common' })"
                                :label="$t('com_avg', { ns: 'common' })"
                            >
                                <temperature-input
                                    v-model.number="localItem.gemTemperatuur"
                                    @change="setChanged"
                                    :editAllowed="editAllowed"
                                    :showFahrenheit="showFahrenheit"
                                />
                            </b-input-group>
                            <b-input-group
                                style="width: 80%"
                                :prepend="$t('com_min', { ns: 'common' })"
                                :label="$t('com_min', { ns: 'common' })"
                            >
                                <temperature-input
                                    v-model.number="localItem.minTemperatuur"
                                    @change="setChanged"
                                    :editAllowed="editAllowed"
                                    :showFahrenheit="showFahrenheit"
                                />
                            </b-input-group>
                            <b-input-group
                                style="width: 80%"
                                :prepend="$t('com_max', { ns: 'common' })"
                                :label="$t('com_max', { ns: 'common' })"
                            >
                                <temperature-input
                                    v-model.number="localItem.maxTemperatuur"
                                    @change="setChanged"
                                    :editAllowed="editAllowed"
                                    :showFahrenheit="showFahrenheit"
                                />
                            </b-input-group>
                        </div>
                    </b-card-text>
                    <b-form-textarea
                        v-model="localItem.opmerking"
                        :placeholder="$t('com_opmerking', { ns: 'common' })"
                        rows="3"
                        max-rows="6"
                        @change="setChanged"
                    ></b-form-textarea>
                </b-tab>
                <b-tab :title="$t('prod_ingredienten', { ns: 'production' })">
                    <div v-if="editAllowed">
                        <div
                            v-for="(el, index) in ingredientenList"
                            v-bind:key="el.product"
                        >
                            <prep-ingredient-combo
                                :element="ingredientenList[index]"
                                :editAllowed="editAllowed && localItem.isNew"
                                @input="check_doubles"
                            /><br />
                        </div>
                    </div>
                </b-tab>
            </b-card>

            <b-table
                :items="displayList"
                :fields="visibleFields"
                stacked="md"
                show-empty
                :empty-text="$t('com_geen_data', { ns: 'common' })"
                small
                striped
            >
                <template v-slot:cell(actions)="row">
                    <b-button
                        v-if="nieuw"
                        size="sm"
                        @click="verwijderItem(row.item)"
                        :disabled="!editAllowed && !localItem.isNew"
                        class="bgc_aux_alarm"
                        ><font-awesome-icon icon="trash-alt" size="1x" />
                    </b-button>
                </template>
            </b-table>
            <h4>
                <b-badge :variant="variantColor" v-if="ingredientenHH > 0"
                    >{{
                        $t('com_totaal', {
                            ns: 'common'
                        })
                    }}
                    = {{ ingredientenHH }}</b-badge
                >
            </h4>
        </div>
    </b-card>
</template>

<script>
import {
    IngredientElement,
    IngredientProduction,
    IngredientRecipe
} from '../../models/Recept';
import { loadItem, loadList } from '../../models/DataHelper';
import Helper from '../../models/Helper';
import DateHelper from '../../models/DateHelper';
import { INGRCAT_ENUM } from '../../models/IngredientCategorie';
import { Feature } from '../../models/Features';
import { LookupCombo, TemperatureInput, CheeseTijd } from '../components';
import PrepIngredientCombo from './PrepIngredientCombo.vue';
export default {
    name: 'CardPrepProduction',
    data() {
        return {
            localItem: new IngredientProduction(this.inItem, true),
            showDismissibleAlert: false,
            alertText: '',
            lctypeUnits: window.constants.LCPERUNITS,
            lctypeLocation: window.constants.LCLOCATION,
            displayList: [],
            prodIngredientList: [],
            lijstRecept: [],
            refresh: false,
            puIngredient: 0,
            buProduct: -1,
            amount: 0,
            nieuw: false,
            isSelected: false,
            showFahrenheit: true,
            productieIngredientID: -1,
            currentRecipe: null,
            temperatuur: null,
            tussentemperatuur: null,
            aangeraakt: 1,
            tijdstart: null,
            datumtijdstart: null,
            tijdeind: null,
            datumtijdeind: null,
            ingredientenHH: 0,
            amountSeemsGood: true,
            recipe: null,
            localDateStart: null,
            localTijdStart: null,
            localDateEind: null,
            localTijdEind: null
        };
    },
    components: {
        TemperatureInput,
        LookupCombo,
        CheeseTijd,
        PrepIngredientCombo
    },
    model: {
        prop: 'inItem'
    },
    props: {
        inItem: {
            type: IngredientProduction,
            required: true
        },
        recept: {
            type: IngredientRecipe,
            default: null
        },
        timeInput: {
            type: Boolean,
            default: false
        },
        editAllowed: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        useTimeInput() {
            if (this.timeInput) {
                return false;
            }
            return !this.checkFeature('conf_UseDateTimePicker');
        },
        configUseFahrenheit() {
            const useF = this.checkFeature('conf_useFahrenheitinProduction');
            return useF;
        },
        buIngredientString() {
            const baseu = this.buIngredient;
            return baseu > -1 ? baseu.toString() : '';
        },
        buProductString() {
            const baseu = this.buProduct;
            return baseu > -1 ? baseu.toString() : '';
        },
        ingredientenList() {
            return this.currentRecipe ? this.currentRecipe.elementen : [];
        },
        giveBGclass() {
            return this.localItem.starttijd != undefined &&
                this.localItem.eindtijd != undefined
                ? 'bg-green'
                : 'bg-blue';
        },
        magEdit() {
            const edit = this.editAllowed;
            const mag = this.editAllowed ? this.nieuw : false;
            return mag;
        },
        variantColor() {
            return this.amountSeemsGood ? 'light' : 'warning';
        },
        visibleFields() {
            const fieldsInit = [
                { key: 'actions', label: ' ', visible: true },
                {
                    key: 'partijID',
                    label: 'Id',
                    sortable: false,
                    visible: false
                },
                {
                    key: 'naam',
                    label: this.$t('com_product', { ns: 'common' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'partijNummer',
                    label: this.$t('com_batch', { ns: 'common' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'hoeveelheid',
                    label: this.$t('com_amount', { ns: 'common' }),
                    visible: true
                },
                {
                    key: 'eenheidNaam',
                    label: this.$t('com_unit', { ns: 'common' }),
                    sortable: true,
                    visible: true
                }
            ];
            return fieldsInit.filter((field) => field.visible);
        }
    },
    methods: {
        showAlert(tekst) {
            this.alertText = tekst;
            this.showDismissibleAlert = true;
        },
        async setProduct(setRecipe = true) {
            this.isSelected = true;
            const product = this.prodIngredientList.find(
                (x) => x.value == this.productieIngredientID
            );
            this.buProduct = product?.baseunit;
            this.localItem.naam = product?.text;
            this.localItem.productID = product?.value;
            this.productieIngredientID = this.localItem.productID;

            if (setRecipe) {
                await this.setRecipe();
                // vul receptwaarden in
                this.fillWithRecipeValues();
            }
            this.$emit('selectedNaam', product.text);
        },
        checkFeature(feature) {
            const key = Feature.enum(feature);
            return this.$root.handleFeature(key);
        },
        set_inputTijdEind(value) {
            const tijd = DateHelper.dateIsValid(value)
                ? value
                : this.localItem.eindtijd ?? new Date();
            this.localItem.eindtijd = DateHelper.convertedFromTimepicker(
                tijd,
                value
            );
            this.tijdeind = DateHelper.convertedToDateTimeString(
                this.localItem.eindtijd
            );
            this.datumtijdeind = DateHelper.convertedToDateTimeJS(
                this.localItem.eindtijd
            );
            this.setChanged();
        },
        set_inputTijdStart(value) {
            const tijd = DateHelper.dateIsValid(value)
                ? value
                : this.localItem.starttijd ?? new Date();
            this.localItem.starttijd = DateHelper.convertedFromTimepicker(
                tijd,
                value
            );
            this.tijdstart = DateHelper.convertedToDateTimeString(
                this.localItem.starttijd
            );
            this.datumtijdstart = DateHelper.convertedToDateTimeJS(
                this.localItem.starttijd
            );
            if (this.nieuw) {
                this.localItem.productiedatum = this.localItem.starttijd;
            }
            this.setChanged();
        },
        setDatumTijdStart() {
            if (this.localDateStart && this.localTijdStart) {
                const dateTime = DateHelper.DateFromInput(
                    this.localDateStart,
                    this.localTijdStart
                );
                this.localItem.starttijd = dateTime;
                if (this.nieuw) {
                    this.localItem.productiedatum = this.localItem.starttijd;
                }
                this.setChanged();
            }
        },
        setDatumTijdEind() {
            if (this.localDateEind && this.localTijdEind) {
                const dateTime = DateHelper.DateFromInput(
                    this.localDateEind,
                    this.localTijdEind
                );
                this.localItem.eindtijd = dateTime;
                this.setChanged();
            }
        },
        setChanged() {
            this.localItem.ischanged = true;
            this.$emit('changed', true);
            this.$emit('input', this.localItem);
        },
        setBatchnumber(date) {
            if (this.localItem.batchID == undefined) {
                const datum = date ?? new Date();
                this.localItem.batchID = Helper.stringformat(
                    '{0}-{1}',
                    DateHelper.DateToYMD(datum),
                    DateHelper.DateToHM(datum)
                );
            }
        },
        setTotaalIngredientenHH() {
            let totaalHH = 0;
            for (let i = 0; i < this.localItem.elementen.length; i++) {
                // tel kilos en liters gewoon bij elkaar op
                const ing = this.localItem.elementen[i];
                const unit = this.$store.getters['components/getUnitbyID'](
                    ing.eenheid
                );
                const ingHH = ing.hoeveelheid * (unit?.factor ?? 1);
                totaalHH += ingHH;
            }
            this.ingredientenHH = Helper.Round(totaalHH, 3);
            if (this.localItem.hoeveelheid) {
                const min = this.ingredientenHH * 0.9;
                const max = this.ingredientenHH * 1.1;
                this.amountSeemsGood =
                    this.localItem.hoeveelheid > min &&
                    this.localItem.hoeveelheid < max;
            }
        },
        check_doubles(inputObject) {
            const el = new IngredientElement(inputObject);

            this.localItem.elementen.push(el);

            const x = _(this.localItem.elementen.slice(0))
                .groupBy((x) => x.partijNummer)
                .map((value, key) => ({
                    categorie: key,
                    bi: value
                }))
                .value();
            const y = x.filter((o) => o.bi.length > 1);
            this.biValid = !(y.length > 0);
            if (y.length > 0) {
                this.showAlert(
                    this.$t('prod_warnuniekinlijst3', {
                        ns: 'production'
                    })
                );
                // todo delete el
                return;
            }
            if (
                this.localItem.receptID == undefined ||
                this.localItem.receptID < 0
            ) {
                this.localItem.receptID = this.currentRecipe.id;
            }
            this.setBatchnumber(this.datumtijdstart);
            this.setTotaalIngredientenHH();
            this.$emit('input', this.localItem);
        },
        fillWithRecipeValues() {
            if (this.currentRecipe == null) return;
            this.localItem.hoeveelheid = this.currentRecipe.hoeveelheid;
            this.localItem.eenheid = this.currentRecipe.eenheid;
            this.localItem.eenheidNaam = this.currentRecipe.eenheidNaam;
            this.localItem.startTemperatuur =
                this.currentRecipe.bewerkingsTemperatuur;
            this.localItem.eindTemperatuur =
                this.currentRecipe.bewerkingsTemperatuur;
            this.aangeraakt += 1; // todo ververs eenheid
        },
        async verwijderItem(item) {
            const doClose = await this.$root.showConfirmationBox(
                this.$t('com_delete', {
                    ns: 'common',
                    val: this.$t('com_product', { ns: 'common' })
                }) +
                    ' : ' +
                    item.naam
            );
            if (doClose) {
                for (let i = this.localItem.elementen.length - 1; i >= 0; i--) {
                    const id = this.localItem.elementen[i].partijID;
                    const test = item.partijID === id;
                    if (test) this.localItem.elementen.splice(i, 1);
                }
                this.setTotaalIngredientenHH();
            }
        },
        async setRecipe() {
            let recept = this.recept;
            this.currentRecipe = null;
            if (recept == undefined) {
                if (this.localItem.receptID && this.localItem.receptID > 0) {
                    // recept is meegegeven, er is al geproduceerd dus edit of alleen tonen
                    recept = this.lijstRecept.find(
                        (x) => x.id == this.localItem.receptID
                    );
                    if (recept == undefined) {
                        this.editOpBasisVanRecept = false;
                    } else {
                        // TODO check op editdagen tov proddate
                        this.editOpBasisVanRecept = true;
                    }
                } else {
                    // alleen product meegegeven of nieuw geselecteerd, edit mag
                    recept = this.lijstRecept.find(
                        (x) => x.productID == this.productieIngredientID
                    );
                    this.editOpBasisVanRecept = true;
                }
            } else {
                // er is een recept meegegeven, productie op basis daarvan, edit mag
                this.editOpBasisVanRecept = true;
            }
            if (recept != undefined) {
                this.currentRecipe = await loadItem(
                    'preparation/loadProductionRecipe',
                    { recipeid: recept.id },
                    this.$t
                );
            } else {
                if (this.localItem.productID != undefined) {
                    this.showAlert(
                        this.$t('prod_novalidrecipe', {
                            ns: 'production'
                        })
                    );
                }
            }
            if (
                this.localItem.receptID == undefined &&
                this.localItem.productID != undefined
            ) {
                this.localItem.receptID = recept.id;
            }
        }
    },
    mounted() {},
    async created() {
        this.showFahrenheit = this.configUseFahrenheit;
        const lijst = await loadList(
            'components/getIngredientComboLijst',
            'components/loadIngredientsForGroupComboLijst',
            null,
            true,
            this.$t
        );
        const filtered = lijst.filter((x) => x.catid == INGRCAT_ENUM.Mix);
        this.prodIngredientList = filtered.map((x) => ({
            value: x.value,
            text: x.naam,
            baseunit: x.baseunit
        }));

        const lijstRecepten = await loadList(
            'preparation/getProductionRecipeLijst',
            'preparation/loadProductionRecipeInfo',
            null,
            this.refresh,
            this.$t
        );
        this.lijstRecept = lijstRecepten.filter((x) => x.verwijderd === null);

        this.productieIngredientID = this.localItem.productID ?? -1;
        this.isSelected = this.productieIngredientID > 0;
        this.aangeraakt += 1; // todo ververs eenheid
        this.nieuw =
            this.localItem.voorraadID == undefined ||
            this.localItem.voorraadID < 0;
        if (
            this.isSelected &&
            (this.localItem.naam == undefined || this.localItem.naam == '')
        ) {
            this.setProduct(false);
        }
        await this.setRecipe();
        if (this.isSelected && !this.localItem.productiedatum) {
            // vul receptwaarden in
            this.fillWithRecipeValues();
        }
        this.displayList = this.localItem.elementen;
        const start =
            this.localItem.starttijd ??
            this.localItem.productiedatum ??
            new Date();
        this.tijdstart = DateHelper.convertedToDateTimeString(start);
        this.datumtijdstart = DateHelper.convertedToDateTimeJS(start);
        if (this.localItem.productiedatum == undefined)
            this.localItem.productiedatum = start;
        const eind = this.localItem.eindtijd ?? new Date();
        this.tijdeind = DateHelper.convertedToDateTimeString(eind);
        this.datumtijdeind = DateHelper.convertedToDateTimeJS(eind);

        this.localDateStart = DateHelper.DateForInput(
            this.datumtijdstart,
            true,
            false
        );
        this.localTijdStart = DateHelper.DateForInput(
            this.datumtijdstart,
            false,
            true
        );

        this.localDateEind = DateHelper.DateForInput(
            this.datumtijdeind,
            true,
            false
        );
        this.localTijdEind = DateHelper.DateForInput(
            this.datumtijdeind,
            false,
            true
        );
        this.setBatchnumber(this.datumtijdstart);
        this.setTotaalIngredientenHH();
    }
};
</script>
<style scoped>
.bg-green {
    background-color: #c1e881 !important;
}
.bg-blue {
    background-color: hwb(203 55% 7%) !important;
}
.fontcolor {
    color: red;
}
</style>
